import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as axe from 'axe-core';
import styles from "./styles.module.scss";
import { Accordion, Divider, Flex, Group, Select, Space, Text, Title } from '@mantine/core';
import { AutomatedAuditLoader, Button, TextInput } from '@common/components';
import { useMediaQuery } from '@mantine/hooks';
import { auditSinglePage, fetchLatestDashboard, fetchLatestReportRetry, singlePageAuditH, singlePagesDataI, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { Table } from 'src/components';
import { ReactComponent as EmptyTable } from 'src/assets/svg/empty-table.svg';
import { Link } from 'react-router-dom';
import { checkValidHttps } from '@common/helpers/checkValidHttps';


interface Issue {
    id: string;
    description: string;
    impact: string;
    help: string;
}

const SinglePageChecker: React.FC = () => {
    const [url, setUrl] = useState('');
    const dispatch = useAppDispatch();

    // const { issuesLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const { loadingauditSinglePage, singlePageAudit, auditSinglePageData, singlePagesData } = useAppSelector((state) => state.tools, shallowEqual);


    const checkUrlAccessibility = async () => {
            if (!url) return;
            dispatch(auditSinglePage({ pageUrl: url,auditStandard:selectedStandard}));

        };
    
    const isMobile = useMediaQuery('(max-width: 991px)');
    const [ selectedStandard , setSelectedStandard ] = useState("A")
    const [ selectPrevSite , setSelectPrevSite ] = useState("")
    const auditStandards: any = [
        'WCAG 2.1A',
        'WCAG 2.1AA',
        'WCAG 2.1AAA'
    ];
    const [previousAudits, setPreviousAudits] = useState([]);

    useEffect(() => {
        dispatch(singlePagesDataI({}));
    
    }, [])
    
    useEffect(() => {
        if (!singlePagesData || !Array.isArray(singlePagesData)) {
          return;
        }
      
        const formattedData:any = singlePagesData.map((item: any) => ({
          value: item.id,
          label: item.pageURL,
        }));
      
        setPreviousAudits(formattedData);
      }, [singlePagesData]);

    return (
        <div style={{ backgroundColor: '#F5F7FA', width: 'calc(100% - 300px)' }}>
            <div className={styles.container_bg}>
                <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>
                    <Flex align={"center"} gap={"sm"}>
                        <Title order={1} id={'mainContent'} color="#264547" className={styles.heading}>
                            Single Page WCAG Checker
                        </Title>
                    </Flex>
                </Flex>
                <Space h={"md"} />
                <Divider />
                <Space h={"md"} />
                <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>
                    <Flex align={"center"} gap={"sm"}>
                        <Select
                            label="Select Audit Standard"
                            placeholder="Choose standard"
                            value={`WCAG 2.1${selectedStandard}`}
                            onChange={(e) => {
                                if (e) {
                                    const level = e.replace('WCAG 2.1', ''); // remove "WCAG 2.1"
                                    setSelectedStandard(level.trim());       // trim spaces and set only "A", "AA", or "AAA"
                                  }
                            }}
                            data={auditStandards}
                            className={styles.auditDropdown}
                        />
                        
                        <Select
                            label="Choose Previous Audits"
                            placeholder="Previous Audits"
                            value={selectPrevSite}
                            onChange={(e) => {
                                if ( !e ) return;
                                setSelectPrevSite(e)
                                dispatch(singlePageAuditH({ pageId : e }));
                            }}
                            data={previousAudits}
                            className={styles.auditDropdown}
                        />
                    </Flex>
                </Flex>


                <Space h={"md"} />
            </div>
            <div className={styles.checkercontainer}>
                {/* <Title color='#264547' order={1}></Title> */}
                {/* <div className={styles.inputsection}> */}
                    <div className={styles.inputsection} >
                        <h3>Check by URL</h3>
                        <TextInput
                            disabled={ loadingauditSinglePage }
                            error={ url && checkValidHttps(url) ? null : 'Enter the full URL of the website. Example: https://vially.io/'}
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="Enter a URL to check"
                            // className={styles.urlinput}
                        />
                        <Space h={"sm"} />
                        <Button onClick={checkUrlAccessibility} className={styles.button} disabled={!checkValidHttps(url) || loadingauditSinglePage}>
                            Check URL
                        </Button>
                    </div>
                    {loadingauditSinglePage && (
                        <>  
                            <Space h={"sm"} />
                            <AutomatedAuditLoader />
                            <Text>Looking For Issues</Text>
                        </>
                    )}
                    <Space h={"sm"} />
                    {/* <WebsitesListComponent /> */}
                    { (auditSinglePageData?.length > 0 && !loadingauditSinglePage)  && <Table showReAudit={false} report={auditSinglePageData}></Table> ||
                        (singlePageAudit?.length > 0)  && <Table showReAudit={false}   report={singlePageAudit}></Table>
                    }
            </div>
        </div>
    );
};

export default SinglePageChecker;
function WebsitesListComponent() {
    const initialWebsites: any[] = [
        { name: 'Google', url: 'https://www.google.com', icon: 'https://www.google.com/favicon.ico', date : '11/11/2024'},
        { name: 'Facebook', url: 'https://www.facebook.com', icon: 'https://www.facebook.com/favicon.ico', date : '10/09/2024'},
        { name: 'Twitter', url: 'https://www.twitter.com', icon: 'https://www.twitter.com/favicon.ico', date : '11/11/2024'},
        { name: 'Twitter', url: 'https://www.twitter.com', icon: 'https://www.twitter.com/favicon.ico', date : '10/09/2024'},

    ];
    return (

        <>
        {
        initialWebsites.map((website, index) => (
            <Link className={styles.prevsiteContainer} to={"#"}>
                <Flex direction={"column"} >
                    <Text weight={500}> Audit Date : {website.date}</Text>
                    <Text size="sm" color="dimmed">
                        URL: {website.url}
                    </Text>
                    
                </Flex>
                <img
                    src={website.icon}
                    alt={website.name}
                    width="20"
                    height="20"
                    style={{ borderRadius: '50%' }}
                />
            </Link>

        ))
}
        </>
    );
}